// Consent and the age line for making an account (ba-005).
// Recorded in the auth user's metadata at sign-up, so there's no table to migrate.
// Bump CONSENT_VERSION whenever the consent wording or the policy it points at changes.

export const AGE_LINE = 16;
export const CONSENT_VERSION = "2026-10-22";
export const PRIVACY_PATH = "/privacy";
export const TERMS_PATH = "/terms";

// Whole years old today, from { year, month, day }. null when the date is missing.
export function ageFrom(birthDate, today = new Date()) {
  if (!birthDate || !birthDate.year || !birthDate.month || !birthDate.day) return null;
  let age = today.getFullYear() - birthDate.year;
  const m = today.getMonth() + 1;
  if (m < birthDate.month || (m === birthDate.month && today.getDate() < birthDate.day)) age -= 1;
  return age;
}

// What goes in supabase.auth.signUp's options.data.
export function consentMetadata(now = new Date()) {
  return {
    age_confirmed: true,
    age_line: AGE_LINE,
    consent_version: CONSENT_VERSION,
    consent_scope: "birth_details_and_answers",
    consent_at: now.toISOString(),
  };
}

// Accounts made before the consent step (before 2026-10-22) have no
// consent_version in their metadata, so they're asked once (ba-011).
export function needsConsentCheck(user) {
  return !!user && !user.user_metadata?.consent_version;
}

// profiles.birth_date ("YYYY-MM-DD") as { year, month, day }, for when the
// chart hasn't loaded. null when missing or malformed.
export function birthDateFromIso(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? { year: +m[1], month: +m[2], day: +m[3] } : null;
}
